"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Async stateful component base
 *
 * A custom component class that other components can extend to 
 * safely update state as the outcome of asynchronous operations 
 * when the component may have unmounted in the meantime.
 *
 * Overrides `setState()` to only perform the state update when 
 * the component is actually mounted, avoiding React's warnings 
 * when a state update is performed on an unmounted component.
 *
 * Components that override the `componentDidMount()` and/or 
 * `componentWillUnmount()` lifecycle methods **must** call the 
 * `super` variants here to ensure `_mounted` is set correctly 
 * and state updates occur!
 * 
 * Original author @heron-web/material (no longer maintained)
 */
class AsyncStatefulComponent extends _react.default.PureComponent {
  /**
   * Mounted?
   *
   * @type {Boolean}
   */
  _mounted = false;

  /**
   * The component mounted.
   *
   * @return {void}
   */
  componentDidMount() {
    this._mounted = true;
  }

  /**
   * The component is unmounting.
   * 
   * @return {void}
   */
  componentWillUnmount() {
    this._mounted = false;
  }

  /**
   * Override `setState()` to only update the state when mounted.
   *
   * @param {Object} state
   * @param {Function} callback optional
   * @return {void}
   */
  setState(state, callback = undefined) {
    if (this._mounted) {
      super.setState(state, callback);
    }
  }
}
var _default = exports.default = AsyncStatefulComponent;